import { forwardRef, Ref } from 'react';
import { IMaskInput } from 'react-imask';

type MaskInputProps = {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    [key: string]: unknown;
};

export function buildHexMaskInput(mask: string, lazy = false) {
    const hexMaxInput = forwardRef((props: MaskInputProps, ref: Ref<HTMLInputElement>) => {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask={mask}
                definitions={{ 0: /[0-9A-Fa-f]/ }}
                placeholderChar={'\u2000'}
                lazy={lazy}
                inputRef={ref}
                prepareChar={str => str.toUpperCase()}
                onAccept={value => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        );
    });
    hexMaxInput.displayName = 'HexMaskInput';

    return hexMaxInput;
}
